<template>
  <div>
    <div v-if="isLoginPage" :class="{languageLogin: isLoginPage, language: !isLoginPage}">
      <!-- [Select language] start -->
          <el-dropdown @command="setLang" style="width: 100%;">
            <span class="el-dropdown-link language__dropdown">
              <font-awesome-icon icon="globe-americas" size="lg"/>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <!--{{$i18n.locale}}-->
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item.language" v-for="item in languages" :key="item.title" >
                <flag :iso="item.flag" v-bind:squared=false /> {{item.title}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
      <!-- [Select language] end -->
    </div>
    <div v-else>
      <el-select v-model="value" :placeholder="$t('modal_select_language')" size="mini" filterable style="width: 100%;">
        <el-option
          v-for="item in languages"
          :key="item.language"
          :label="item.title"
          :value="item.language"
          @click.native="setLang(item.language)">
          <flag :iso="item.flag" v-bind:squared=false /> {{item.title}}
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SelectLanguage',
  data() {
    return {
      value: '',
      isLoginPage: false,
       languages: [
         { flag: 'gb', language: 'en', title: 'English' },
         { flag: 'ph', language: 'tl', title: 'Filipino' },
         { flag: 'es', language: 'es', title: 'Spanish' },
         { flag: 'cn', language: 'zh', title: 'Chinese' },
         { flag: 'ru', language: 'ru', title: 'Russian' },
         { flag: 'pt', language: 'pt', title: 'Portuguese' },
         { flag: 'de', language: 'de', title: 'German' },
         { flag: 'it', language: 'it', title: 'Italian' },
         { flag: 'kr', language: 'ko', title: 'Korean' }
			].sort((a, b) => a.title.localeCompare(b.title))
    }
  },
  beforeCreate() {

  },
  created(){
    if(this.$route.name === 'login' || this.$route.name === 'reset' || this.$route.name === 'confirm-email' || this.$route.name === 'reset-password-confirm' || this.$route.name === 'signup' || this.$route.name === 'invite-user'  || this.$route.name === 'mail-notification'){
      this.isLoginPage = true
    }
  },
  methods: {
    setLang(lang){
      localStorage.setItem('lang', lang);
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .get(sessionStorage.getItem('token') ? `/api/v1/translations/lang?token=${sessionStorage.getItem('token')}&lang=${lang}` : `/api/v1/translations/lang?lang=${lang}` )
              .then(response => {
                console.log("languages", response.data)
                this.$i18n.setLocaleMessage(lang, response.data)
                if (this.$route.name === 'signup') this.$emit('getNewLinksList')
                // if(lang === 'ru'){
                //   this.$i18n.setLocaleMessage(lang, response.data)
                // }else if (lang === 'en'){
                //   this.$i18n.setLocaleMessage(lang, response.data)
                // }
                console.log('MY LANG', lang)
                this.$i18n.locale = lang
                console.log("l18n", this.$i18n)
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    },
  },
  // init => {
  //   const lang = localStorage.getItem('lang') || 'en'
  //   // Проверяешь язык из списка возможных языков
  //   // Вызываешь функцию, которая делает запрос на получение переводов
  // }
//   setLang(lang) => {
//   localeStorage.saveItem('lang', lang)
//   axios.get(`/api/v1/translations/lang/${lang}`).then(resp => this.$set(this.$i18n.messages, lang, resp.data))
//   this.$i18n.locale = lang
// }
}
</script>

<style lang="scss" scoped>
.languageLogin {
  position:absolute;
  top: 3%;
  right: 4%;
  &__dropdown {
    font-weight: 900;
  }
}
.language{
  width:40px;
  color:#ffff;
  display: flex;
  align-items: center;
  margin:0 10px;
  .el-dropdown-link{
    cursor: pointer;
    color: #fff;
  }
}
.row-padding {
  padding: 40px 0;
}

.el-dropdown-link {
  cursor: pointer;
  color: #000;
}
</style>
